<template>
  <b-button
    :type="type"
    :disabled="!enabled"
    :variant="variant"
    @click="clickHandler"
  >
    <b-spinner v-if="running" small></b-spinner>
    {{label}}
  </b-button>
</template>

<script>
export default {
  name: 'ActionButton',

  props: {
    type: {
      type: String,
      default: 'button',
    },

    variant: {
      type: String,
      default: 'secondary',
    },

    enabled: {
      type: Boolean,
      default: true,
    },

    running: {
      type: Boolean,
      default: false,
    },

    idleLabel: {
      type: String,
      required: true,
    },

    runningLabel: {
      type: String,
      required: true,
    },
  },

  computed: {
    label() {
      return this.running ? this.runningLabel + '...' : this.idleLabel;
    },
  },

  methods: {
    clickHandler(event) {
      this.$emit('click', event);
    },
  },
};
</script>
